import { z } from 'zod';
import { ZIntegrationRequestEnvelope } from './integration-request-envelope.js';
export const ZIntegrationEvent = z.object({
    shopId: z.string(),
    id: z.string().uuid(),
    provider: z.string(),
    eventName: z.string(),
    status: z.enum(['sent', 'errored']),
    side: z.enum(['server', 'client']),
    sentAt: z.iso.datetime(),
    durationMs: z.number(),
    error: z.string().optional(),
    deduplicationId: z.string().optional(),
    payload: z.record(z.string(), z.unknown()),
    request: ZIntegrationRequestEnvelope.optional(),
});
//# sourceMappingURL=integration-event.js.map